import { ActionReducerMap } from '@ngrx/store';
import { AppState } from '../state/app.state';
import { ltiReducer } from './ltiparams.reducer';

export const appReducers: ActionReducerMap<AppState, any> = {
  ltiParamsState: ltiReducer,
};
